"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postLinkedinArticle = exports.postLinkedinArticleProxy = exports.getLinkedInUserIdProxy = exports.getLinkedInAccessToken = void 0;
const constants_1 = require("../../constants/constants");
const axiosConfig_1 = require("../axios/axiosConfig");
const getLinkedInAccessToken = (code, redirectUri) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let result = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.SignUpRoutes.linkedInAccessToken(), {
            code,
            redirect: redirectUri || `${window.location.origin}/en/linkedinRedir`,
        }, { suppressNetworkError: true });
        return result.data.access_token;
    }
    catch (error) {
        return null;
    }
});
exports.getLinkedInAccessToken = getLinkedInAccessToken;
const getLinkedInUserIdProxy = (token) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let res = yield fetch(constants_1.LinkedinRoutes.linkedinProxy(), {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                url: "https://api.linkedin.com/v2/me",
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }),
        });
        let resJson = yield (res === null || res === void 0 ? void 0 : res.json());
        return (resJson === null || resJson === void 0 ? void 0 : resJson.id) ? resJson.id : null;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.getLinkedInUserIdProxy = getLinkedInUserIdProxy;
const postLinkedinArticleProxy = (token, userId, articleUrl, postTitle) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        var bearer = "Bearer " + token;
        var author = "urn:li:person:" + userId;
        var body = {
            author: author,
            lifecycleState: "PUBLISHED",
            specificContent: {
                "com.linkedin.ugc.ShareContent": {
                    shareCommentary: {
                        text: postTitle,
                    },
                    shareMediaCategory: "ARTICLE",
                    media: [
                        {
                            status: "READY",
                            originalUrl: articleUrl,
                        },
                    ],
                },
            },
            visibility: {
                "com.linkedin.ugc.MemberNetworkVisibility": "PUBLIC",
            },
        };
        let res = yield fetch(constants_1.LinkedinRoutes.linkedinProxy(), {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                url: "https://api.linkedin.com/v2/ugcPosts",
                method: "POST",
                headers: {
                    Accept: "application/json",
                    Authorization: bearer,
                    "X-Restli-Protocol-Version": "2.0.0",
                },
                body: JSON.stringify(body),
            }),
        });
        let resJson = yield res.json();
        return resJson;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.postLinkedinArticleProxy = postLinkedinArticleProxy;
const postLinkedinArticle = (token, userId, articleUrl, credentialTitle, postTitle, credentialNo) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        var bearer = "Bearer " + token;
        var author = "urn:li:person:" + userId;
        let body = {
            author: author,
            credentialTitle: credentialTitle,
            postTitle: postTitle,
            token: bearer,
            articleUrl: articleUrl,
        };
        let finalBody = {};
        if (credentialNo) {
            finalBody = Object.assign(Object.assign({}, body), { credential_no: credentialNo });
        }
        else {
            finalBody = Object.assign(Object.assign({}, body), { isVelocity: true });
        }
        let res = yield fetch(constants_1.LinkedinRoutes.sharePostLinkedin(), {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(finalBody),
        });
        let resJson = yield res.json();
        return resJson;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.postLinkedinArticle = postLinkedinArticle;
